"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconVideo = function IconVideo(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconVideo', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.167 2.188c.966 0 1.75.807 1.75 1.804L9.916 5.83l3.162-2.327c.386-.285.922 0 .922.49v6.015c0 .49-.536.774-.922.49l-3.162-2.33v1.84c0 .997-.783 1.805-1.75 1.805H1.75c-.966 0-1.75-.808-1.75-1.805V3.992c0-.997.784-1.804 1.75-1.804h6.417zm0 1.203H1.75a.593.593 0 0 0-.583.601v6.016c0 .332.26.601.583.601h6.417c.322 0 .583-.269.583-.601V3.992a.593.593 0 0 0-.583-.601zm4.666 1.77L10.337 7l2.496 1.839V5.16z"
  }));
};

var _default = IconVideo;
exports.default = _default;